import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import useTranslate from '../../Hooks/useTranslate';
import ReportListSheet from './ReportListSheet';
import useMobileNavigation from './useMobileNavigation';

/**
 * "Cambia lista" bottom sheet: switches the Contatti tab between AllCustomers, the Wave segments
 * and Birthdays.
 */
const ListSheet = function ListSheet({ open = false, onClose = () => {} }) {
  const translate = useTranslate();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  // Only the lists the user holds, each at the address the desktop serves it at.
  const { lists, findActiveList } = useMobileNavigation();

  return (
    <ReportListSheet
      open={open}
      onClose={onClose}
      title={translate('CHANGE_LIST')}
      items={lists.map((list) => ({
        ...list,
        label: translate(list.labelKey),
      }))}
      value={findActiveList(pathname)?.key}
      onChange={(list) => {
        if (list.path !== pathname) navigate(list.path);
      }}
    />
  );
};

export default ListSheet;
